export default __webpack_public_path__ + "static/media/bg2.7bf18d90.jpg";